<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div
      v-if="myData.data"
      slot="content"
      :class="{'img-radius':pattern.showImgBorderRadius}"
      @click="onClickitem(myData.data)"
    >
      <!-- 标题栏和状态栏占位符 -->
      <van-image lazy-load :src="showText('src',myData.data)" mode="widthFix" />
      <span class="name flex-center">{{showText('name',myData.data)}}</span>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Object,
      default: () => {
        return {
          type: 'product',
          data: null
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: true,
          showRightPadding: true,
          showTopPadding: true,
          showBottomPadding: true,
          showImgBorderRadius: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      myData: this.data,
      //数据解析器
      formats: {
        product: {
          //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxProductList, 'get', { page: 1, size: 1 }).then(res => {
              let data = res.data
              this.myData.data = data.list.length >= 1 ? data.list[0] : null
            })
          },
          refreshDataFunc: () => {
            let ids = []
            if (this.myData.data.id) {
              ids.push(this.myData.data.id)
            }
            this.$http.request(this.$http.pathMap.refreshWxProductList, 'post', ids).then(res => {
              let data = res.data
              if (data.length > 0) {
                this.myData.data = data[0]
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/pages/product/product',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/pages/category/category';
          }
        },
        video: { //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: 1, type: 1 }).then(res => {
              let data = res.data
              this.myData.data = data.list.length >= 1 ? data.list[0] : null
            })
          },
          refreshDataFunc: () => {
            let ids = []
            if (this.myData.data.id) {
              ids.push(this.myData.data.id)
            }
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 1 }).then(res => {
              let data = res.data
              if (data.length > 0) {
                this.myData.data = data[0]
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        audio: { //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: 1, type: 2 }).then(res => {
              let data = res.data
              this.myData.data = data.list.length >= 1 ? data.list[0] : null
            })
          },
          refreshDataFunc: () => {
            let ids = []
            if (this.myData.data.id) {
              ids.push(this.myData.data.id)
            }
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 2 }).then(res => {
              let data = res.data
              if (data.length > 0) {
                this.myData.data = data[0]
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        image: { //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: 1, type: 3 }).then(res => {
              let data = res.data
              this.myData.data = data.list.length >= 1 ? data.list[0] : null
            })
          },
          refreshDataFunc: () => {
            let ids = []
            if (this.myData.data.id) {
              ids.push(this.myData.data.id)
            }
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 3 }).then(res => {
              let data = res.data
              if (data.length > 0) {
                this.myData.data = data[0]
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        live: {
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxLiveList, 'get', { page: 1, size: 1 }).then(res => {
              let data = res.data
              this.myData.data = data.list.length >= 1 ? data.list[0] : null
            })
          },
          refreshDataFunc: () => {
            let ids = []
            if (this.myData.data.id) {
              ids.push(this.myData.data.id)
            }
            this.$http.request(this.$http.pathMap.refreshWxLiveList, 'post', ids).then(res => {
              let data = res.data
              if (data.length > 0) {
                this.myData.data = data[0]
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'cover',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/live/live',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/live/list';
          }
        },
      },
    };
  },

  created () {
    this.refreshData()
  },
  methods: {
    //数据展示
    showText (key, item) {
      let text = this.formats[this.data.type].dataSwitch[key].format(item[this.formats[this.data.type].dataSwitch[key].key], item)
      return text
    },
    //默认的数据格式化
    defaultFormat (text) {
      return text
    },
    defaultSrcFormat (text) {
      let type = this.$getType(text)
      if (type == '[object Array]') {
        return text.length > 0 ? text[0] : ''
      } else if (type == '[object String]') {
        try {
          let texts = JSON.parse(text)
          return texts.length > 0 ? texts[0] : ''
        } catch{
          return text
        }
      }
      return ''
    },
    onClickMore () {
      this.$router.push(this.formats[this.data.type].moreRouter())
    },
    onClickitem (item) {
      this.$router.push(this.formats[this.data.type].detailRouter(item))
    },
    refreshData () {
      if (!this.data.data) {
        this.formats[this.data.type].getDataFunc()
      } else {
        if (this.type == 'default') {
          this.formats[this.data.type].refreshDataFunc()
        }
      }
    },
    warchRefreshData () {
      if (!this.data.data) {
        this.formats[this.data.type].getDataFunc()
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (newVal, oldVal) {
        let myDataStr = JSON.stringify(oldVal)
        let newValStr = JSON.stringify(newVal)
        if (myDataStr != newValStr) {
          this.myData = JSON.parse(JSON.stringify(newVal))
          this.refreshData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
}
.name {
  margin-top: 5px;
  font-size: $uni-font-size-lg;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.img-radius {
  border-radius: 12px;
  overflow: hidden;
}
</style>
